import { render } from "./ModalSendOrder.vue?vue&type=template&id=600e4224"
import script from "./ModalSendOrder.vue?vue&type=script&lang=js"
export * from "./ModalSendOrder.vue?vue&type=script&lang=js"

import "./ModalSendOrder.vue?vue&type=style&index=0&id=600e4224&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__